import { render, staticRenderFns } from "./inputBuscaTags.vue?vue&type=template&id=3b34d55a&scoped=true&"
import script from "./inputBuscaTags.vue?vue&type=script&lang=js&"
export * from "./inputBuscaTags.vue?vue&type=script&lang=js&"
import style0 from "./inputBuscaTags.vue?vue&type=style&index=0&id=3b34d55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34d55a",
  null
  
)

export default component.exports